import { useAppSelector } from 'hooks/useStore'
import { ReactElement, useEffect, useMemo, useState } from 'react'
import { Theme } from 'theme/theme'
import { componentByMonth } from './dashboardFigures.helpers'
import DownloadButton from 'components/DownloadButton'
import { QuotationClass, QuotationComptaStatus } from '@Arti-zen/package-backoffice'
import { ApiArtizenBO } from 'utils/artizenConnector'
import { fetchAllPages } from 'utils/async'
import { Button } from '@mui/material'
import { Format } from 'utils/format'

export default function DashboardQuotationsFigures(): ReactElement {
  const { dateStart, dateEnd } = useAppSelector((state) => state.dashboard)
  const [quotations, setQuotations] = useState<QuotationClass['meilisearchDoc'][]>([])
  const [isLoading, setIsLoading] = useState(false)
  const [needRefresh, setNeedRefresh] = useState(true)

  useEffect(() => {
    setNeedRefresh(true)
  }, [dateStart, dateEnd])
  
  const refresh = () => {
    setIsLoading(true)
    setNeedRefresh(false)

    fetchAllPages(ApiArtizenBO.quotations.get, {
      startDate: dateStart.toJSDate(),
      endDate: dateEnd.toJSDate(),
    }, { chunkSize: 7 })
      .then(setQuotations)
      .finally(() => setIsLoading(false))
  }

  

  type TStats = Record<number, Record<number, { count: number; totalHtCts: number }>>

  const stats = useMemo<TStats>(() => {
    return quotations.reduce((acc, quot) => {
      if (quot.status !== QuotationComptaStatus.Draft) return acc
      const d = new Date(quot.creationDate)

      const year = d.getFullYear()
      const month = d.getMonth() + 1 // 1-12

      if (!acc[year]) {
        acc[year] = {}
      }

      if (!acc[year][month]) {
        acc[year][month] = {
          count: 0,
          totalHtCts: 0,
        }
      }

      acc[year][month].count += 1
      acc[year][month].totalHtCts += quot.totalTTC_cts

      return acc
    }, {} as TStats)
  }, [quotations])


  if (needRefresh) {
    return <>
      <Button variant="contained" onClick={refresh}>Actualiser</Button>
    </>
  }

  return isLoading ? (
    <>Chargment en cours ...</>
  ) : (
    <>
      <td
        style={{
          fontWeight: 600,
          color: Theme.colors.blueArtizen,
          display: 'flex',
          flexDirection: 'row',
          gap: 10,
          alignItems: 'center',
        }}
      >
        Devis
        {!!quotations && <DownloadButton data={quotations} fileName="quotations" label={null} size="small" />}
      </td>
      {!stats ? null : (
        <>
          <tr>
            <td style={{ textAlign: 'right' }}>Nombre</td>
            {componentByMonth({
              dateStart,
              dateEnd,
              component: (year, month) => (
                <td style={{ padding: 10, textAlign: 'center' }}>
                  <div>{Format.number(stats[year]?.[month]?.count || 0)}</div>
                </td>
              ),
            })}
          </tr>
          <tr>
            <td style={{ textAlign: 'right' }}>TOTAL HT</td>
            {componentByMonth({
              dateStart,
              dateEnd,
              component: (year, month) => (
                <td style={{ padding: 10, textAlign: 'center' }}>
                  <div>{Format.currency((stats[year]?.[month]?.totalHtCts || 0) / 100)}</div>
                </td>
              ),
            })}
          </tr>
        </>
      )}
    </>
  )
}
